
export default function About() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              About Edgeway Auto
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Edgeway Auto is a trusted wholesale automotive company dedicated to connecting dealers, 
              investors, and industry professionals with quality vehicles at competitive prices.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We specialize in acquiring, managing, and distributing wholesale inventory across multiple 
              markets, leveraging our expertise and network to create consistent opportunities for growth. 
              Whether you're a dealer looking for reliable inventory, an investor seeking strong returns, 
              or a partner in the automotive space, Edgeway Auto provides the structure, support, and 
              professionalism to help you succeed.
            </p>
            
            <div className="grid grid-cols-2 gap-8 mt-12">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">$50M+</div>
                <p className="text-gray-600">Annual Volume</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">98%</div>
                <p className="text-gray-600">Client Satisfaction</p>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/0953acd955039581aa797f1f5b07ea5a.jpg"
              alt="Professional automotive business meeting"
              className="w-full h-full object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
